import React from 'react';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import { CancelButton, UpdateButton } from '../../../../components/mui/Buttons/Buttons';
import { Box, Stack, TextField } from '@mui/material';
import GlobalSelectField from '../../../../components/mui/GlobalSelectField';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { croTrainerStatusChange, getStudentListAndTutorList } from '../../../../redux/features/CRDslice';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
export const croUpdateStatusOptions = [
  { id: 1, value: 'Interested' },
  { id: 2, value: 'Not Interested' },
  { id: 3, value: 'Call Not Attended' },
  { id: 4, value: 'Confirmed  ' },
];
const StatusChangeWithRemarks = ({ open, setOpen, row, subjectEnrollmentId, dispatchParams }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { loading } = useSelector((store) => store.crd);
  const initialValues = {
    trainerStatusId: row ? row.trainerStatusId : '',
    remarks: row ? row.lead_remarks : '',
  };
  const schema = Yup.object({
    remarks: Yup.string().required('Remarks is required'),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      const data = 
        {
          remarks: values.remarks,
          status: values.trainerStatusId,
          subject_enrollment_id:subjectEnrollmentId,
          trainer_id: row.trainer_id,
        };
      
      dispatch(croTrainerStatusChange(data)).then((res) => {
        if (res.payload.status === 'error') {
          enqueueSnackbar(res.payload.message, {
            variant: 'error',
          });
        } else if (res.payload.status === 'success') {
          dispatch(getStudentListAndTutorList(dispatchParams));
          handleCancel();
          enqueueSnackbar(res.payload.message, {
            variant: 'success',
          });
        }
      });
    },
  });

  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };

  return (
    <GlobalDialog
      maxWidth={'sm'}
      fullWidth
      title={'Status Change with Remarks'}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      content={
        <>
          <>
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Stack gap={2}>
                  <Box>
                    <GlobalSelectField
                      options={{
                        formik: formik,
                        label: 'Trainer Status',
                        name: 'trainerStatusId',
                        data: croUpdateStatusOptions,
                        keys: {
                          id: 'id',
                          value: 'value',
                        },
                        sx: {
                          width: '100%',
                        },
                      }}
                    />
                  </Box>
                  <Box>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      id="remarks"
                      label="Remarks"
                      name="remarks"
                      value={formik.values.remarks}
                      onChange={formik.handleChange}
                      error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                      helperText={formik.touched.remarks && formik.errors.remarks}
                    />
                  </Box>
                </Stack>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                  <Stack direction={'row'} spacing={1}>
                    <CancelButton action={() => handleCancel()}>Cancel</CancelButton>

                    <UpdateButton disabled={loading} type="submit">
                      {loading ? 'Updating...' : 'Update'}
                    </UpdateButton>
                  </Stack>
                </Box>
              </Form>
            </FormikProvider>
          </>
        </>
      }
    />
  );
};

export default StatusChangeWithRemarks;
